// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__dIz3G","sendOtp":"AuthorizeToLogin_sendOtp__2ThIL"};